/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Card_Rating_Count_OtherInputs */

const en_directory_card_rating_count_other = /** @type {(inputs: Directory_Card_Rating_Count_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ratings`)
};

const zh_directory_card_rating_count_other = /** @type {(inputs: Directory_Card_Rating_Count_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 条评分`)
};

/**
* | output |
* | --- |
* | "{count} ratings" |
*
* @param {Directory_Card_Rating_Count_OtherInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_card_rating_count_other = /** @type {((inputs: Directory_Card_Rating_Count_OtherInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Card_Rating_Count_OtherInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_card_rating_count_other(inputs)
	return zh_directory_card_rating_count_other(inputs)
});
export { directory_card_rating_count_other as "directory.card.rating_count_other" }